// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._RkapjXyJkXgaq5d {
  max-width: 1365px;
  margin: 0 auto;
}

._RkapjXyJkXgaq5d .p-orderlist-controls {
  display: none;
}

.py3sW3Bx2lsKNX5A {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.AK5X0BQQwF8tXipT,
.UQZBC3SxllgwWvWU {
  display: flex;
}

.AK5X0BQQwF8tXipT > div,
.UQZBC3SxllgwWvWU > div {
  width: 25%;
  align-self: center;
}

.d1ZdVqDwQts8QI41 {
  width: 300px;
  padding: 12px 10px;
  border-radius: 16px;
}

.xR9s4MvcLNgPLlMo {
  color: #000000;
  background-color: transparent;
  border: none;
  padding: 0;
}

.xR9s4MvcLNgPLlMo i {
  font-size: 16px;
  background-color: #f2e1bc;
  padding: 10px;
  border-radius: 8px;
  margin-right: 12px;
}

.hl4SIjcSx5owzpDT {
  margin: 0;
  padding: 0;
  height: 85px;
}

.hl4SIjcSx5owzpDT .p-orderlist-header {
  background-color: #f2e1bc;
  border-radius: 16px 16px 0px 0px;
}

.hl4SIjcSx5owzpDT .p-orderlist-list {
  border-radius: 0px 0px 16px 16px;
}

.UQZBC3SxllgwWvWU {
  height: 100%;
}

.AK5X0BQQwF8tXipT > .QBC35JF2pF4dUEEN,
.UQZBC3SxllgwWvWU > .QBC35JF2pF4dUEEN {
  width: 95px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-shrink: 0;
}

.VXfasF6bqr0tAMmL {
  width: 114px;
  height: 67px;
}

.rp2GoM_r5wU_wHHG {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.iYa1dTGHSAhjzDJo,
.sRkHkq7bWzAupkHk {
  width: 75px;
  height: 67px;
}

.iYa1dTGHSAhjzDJo span::before {
  color: #4d87be;
  font-size: 20px;
}

.sRkHkq7bWzAupkHk span::before {
  color: #dd0000;
  font-size: 20px;
}

.hl4SIjcSx5owzpDT .p-orderlist-list li:hover .iYa1dTGHSAhjzDJo {
  background-color: #e1e7ed;
}

.hl4SIjcSx5owzpDT .p-orderlist-list li:hover .sRkHkq7bWzAupkHk {
  background-color: #ffcaca;
}

.QoDHM8xhnBwPhAfm {
  background-color: inherit !important;
  border: inherit !important;
  color: #65717B;
}

.QoDHM8xhnBwPhAfm:hover {
  background-color: #DFDFDF !important;
}

.pnezgTf6ng4K5JMo {
  width: 100%;
  background-color: #DD0000;
  border-radius: 16px;
  padding: 18px 20px;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  border: none;
}

.pnezgTf6ng4K5JMo:hover {
  background-color: #721010;
}

.cMWSguHWcs8uOrfo {
  width: 100%;
  background-color: #F3F5F7;
  border-radius: 16px;
  padding: 10px 20px;
  color: #4D87BE;
  font-size: 20px;
  font-weight: 600;
  border: none;
}

.cMWSguHWcs8uOrfo:hover {
  color: #305375;
}

.Z9iwHkKLwQQ6ntdN {
  width: 541px !important;
  height: 354px !important;
  background-color: #F3F5F7;
  border-radius: 25px !important;
}

.Z9iwHkKLwQQ6ntdN .p-dialog {
  border-radius: 25px !important;
  background-color: #F3F5F7;
}

.Z9iwHkKLwQQ6ntdN .p-dialog-footer {
  border-bottom-right-radius: 25px !important;
  border-bottom-left-radius: 25px !important;
  background-color: #F3F5F7;
}

.Z9iwHkKLwQQ6ntdN .p-dialog-header {
  border-top-right-radius: 25px !important;
  border-top-left-radius: 25px !important;
  background-color: #F3F5F7;
}

.Z9iwHkKLwQQ6ntdN .p-dialog-content{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.Z9iwHkKLwQQ6ntdN .OlWviwg2PUgzCdSm {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
}

.Z9iwHkKLwQQ6ntdN .p-dialog-title {
  font-size: 30px !important;
  font-weight: 700 !important;
}

.Z9iwHkKLwQQ6ntdN .p-dialog-content {
  background-color: #F3F5F7;
}

.MMxSsOen_k0MGQzh {
  width: 42.125rem !important;
  height: fit-content !important;
  border-radius: 1rem !important;
}

.MMxSsOen_k0MGQzh .p-dialog-content {
  background-color: #F3F5F7;
  height: fit-content !important;
}

.MMxSsOen_k0MGQzh .p-dialog {
  border-radius: 1rem !important;
}

.MMxSsOen_k0MGQzh .p-dialog-header {
  background-color: #F3F5F7;
  border-top-right-radius: 1rem !important;
  border-top-left-radius: 1rem !important;
}

.MMxSsOen_k0MGQzh .p-dialog-footer {
  background-color: #F3F5F7;
  border-bottom-right-radius: 1rem !important;
  border-bottom-left-radius: 1rem !important;
}

.MMxSsOen_k0MGQzh .p-dialog-title {
  font-size: 1.875rem !important;
  font-weight: 700 !important;
}

.MMxSsOen_k0MGQzh .field label {
  font-size: 1.25rem !important;
  font-weight: 400 !important;
}

.AgzvqLIEJogxJej0 {
  border-radius: 16px;
  font-size: 18px;
  padding: 14px 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);
}

.JJkGFW9_nbk8ROV_ {
  background-color: #e1e7ed;
  border-radius: 16px;
  overflow: hidden;
}

.JJkGFW9_nbk8ROV_ .p-button {
  background-color: transparent;
  border: none;
  font-size: 20px;
  padding: 15px 0px;
}

.JJkGFW9_nbk8ROV_ .p-highlight {
  background-color: #4d87be;
  border-radius: 16px;
}

.HyMOyeYtr48JKEt5 {
  width: 100%;
  background-color: #56be4d;
  border-radius: 16px;
  padding: 18px 0px;
  color: #ffffff;
  border: none;
  font-size: 20px;
  font-weight: 600;
}

.HyMOyeYtr48JKEt5:hover {
  background-color: #185625;
}

.p82ZaIxZAdQzdPFt {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 15px;
}

.bauKJZtmfUHXvdyO {
  background: #ffffff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
  display: grid;
  grid-template-columns: 2fr 2fr 1fr;
  align-items: center;
}

.WTaiB_6fZKcn34ou {
  display: flex;
  flex-direction: column;
}

.tXChdoYj3EdXj0wU {
  font-weight: 500;
  color: #303030;
  font-size: 14px;
}

.pBcgYnbhkfDHiCDA {
  color: #888888;
  font-weight: 400;
  font-size: 12px;
  margin-left: 3px;
}

.ahj91rQAoAEpGW3N {
  display: flex;
  gap: 12px;
}

.fSI8puu5TYAotecZ {
  color: #1976d2;
  background: none;
  border: none;
}

.TwRDpHz08b4DRhkw {
  color: #d32f2f;
  background: none;
  border: none;
}

.pJDbA9kNYEMjDs_9 {
  background: none;
  border: none;
  color: #65717B;
}

.pJDbA9kNYEMjDs_9:disabled {
  color: #BFC4C8;
}

.pJDbA9kNYEMjDs_9 i::before,
.fSI8puu5TYAotecZ i::before,
.TwRDpHz08b4DRhkw i::before {
  font-size: 18px;
}

@media screen and (max-width: 686px) {
  .Z9iwHkKLwQQ6ntdN,
  .MMxSsOen_k0MGQzh {
    width: 350px !important;
  }
  
  .MMxSsOen_k0MGQzh .field label {
    font-size: 14px !important;
  }
  
  .Z9iwHkKLwQQ6ntdN .p-dialog-title,
  .MMxSsOen_k0MGQzh .p-dialog-title {
    font-size: 20px !important;
    font-weight: 700 !important;
  }
  
  .Z9iwHkKLwQQ6ntdN .OlWviwg2PUgzCdSm {
    font-size: 16px;
  }
  
  .AgzvqLIEJogxJej0 {
    font-size: 14px;
    padding: 14px 20px;
    background-color: #ffffff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);
  }
  
  .HyMOyeYtr48JKEt5 {
    padding: 14px 0;
    font-size: 16px;
  }
  
  .pnezgTf6ng4K5JMo {
    border-radius: 8px;
    padding: 14px 16px;
    font-size: 16px;
  }
  
  .cMWSguHWcs8uOrfo {
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 16px;
  }
  
  .JJkGFW9_nbk8ROV_ {
    background-color: #e1e7ed;
    border-radius: 8px;
    overflow: hidden;
  }
  
  .JJkGFW9_nbk8ROV_ .p-button {
    background-color: transparent;
    border: none;
    font-size: 16px;
    font-weight: 500;
    padding: 15px 0;
  }
  
  .JJkGFW9_nbk8ROV_ .p-highlight {
    background-color: #4d87be;
    border-radius: 8px;
  }
}

@media screen and (max-width: 545px) {
  .py3sW3Bx2lsKNX5A {
    flex-direction: column;
    justify-content: flex-start;
    align-items: start;
  }
  
  .py3sW3Bx2lsKNX5A h2 {
    font-size: 20px;
    font-weight: 700;
  }
  
  .d1ZdVqDwQts8QI41 {
    width: 100%;
    font-size: 14px !important;
    border-radius: 16px;
    padding: 4px 6px;
    height: 44px;
  }
  
  .d1ZdVqDwQts8QI41::placeholder {
    font-size: 14px;
  }
  
  .xR9s4MvcLNgPLlMo {
    width: 100%;
    height: 26px;
    border-radius: 6px;
    margin-bottom: 14px;
  }
  
  .xR9s4MvcLNgPLlMo span {
    display: none;
  }
  
  .xR9s4MvcLNgPLlMo i {
    width: 100%;
    font-size: 14px;
    background-color: #f2e1bc;
    padding: 10px;
    border-radius: 6px;
    margin-right: 0;
  }
  
  .V9wP5i44TEIrA5CM {
    font-size: 12px;
    font-weight: 400;
    color: #7B7B7B;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Manager/components/DiningOptions.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sGAAsG;AACxG;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gDAAgD;EAChD,aAAa;EACb,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE;;IAEE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,sGAAsG;EACxG;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;AACF","sourcesContent":[".pageWrapper {\r\n  max-width: 1365px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.pageWrapper :global(.p-orderlist-controls) {\r\n  display: none;\r\n}\r\n\r\n.pageHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.header,\r\n.diningOptionItem {\r\n  display: flex;\r\n}\r\n\r\n.header > div,\r\n.diningOptionItem > div {\r\n  width: 25%;\r\n  align-self: center;\r\n}\r\n\r\n.dropdown {\r\n  width: 300px;\r\n  padding: 12px 10px;\r\n  border-radius: 16px;\r\n}\r\n\r\n.createBtn {\r\n  color: #000000;\r\n  background-color: transparent;\r\n  border: none;\r\n  padding: 0;\r\n}\r\n\r\n.createBtn i {\r\n  font-size: 16px;\r\n  background-color: #f2e1bc;\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n  margin-right: 12px;\r\n}\r\n\r\n.orderListItem {\r\n  margin: 0;\r\n  padding: 0;\r\n  height: 85px;\r\n}\r\n\r\n.orderListItem :global(.p-orderlist-header) {\r\n  background-color: #f2e1bc;\r\n  border-radius: 16px 16px 0px 0px;\r\n}\r\n\r\n.orderListItem :global(.p-orderlist-list) {\r\n  border-radius: 0px 0px 16px 16px;\r\n}\r\n\r\n.diningOptionItem {\r\n  height: 100%;\r\n}\r\n\r\n.header > .column1,\r\n.diningOptionItem > .column1 {\r\n  width: 95px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.activeBtn {\r\n  width: 114px;\r\n  height: 67px;\r\n}\r\n\r\n.cellSoundWrapper {\r\n  display: flex;\r\n  gap: 8px;\r\n  justify-content: center;\r\n}\r\n\r\n.soundBtn,\r\n.deleteBtn {\r\n  width: 75px;\r\n  height: 67px;\r\n}\r\n\r\n.soundBtn span::before {\r\n  color: #4d87be;\r\n  font-size: 20px;\r\n}\r\n\r\n.deleteBtn span::before {\r\n  color: #dd0000;\r\n  font-size: 20px;\r\n}\r\n\r\n.orderListItem :global(.p-orderlist-list li:hover) .soundBtn {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.orderListItem :global(.p-orderlist-list li:hover) .deleteBtn {\r\n  background-color: #ffcaca;\r\n}\r\n\r\n.arrowBtn {\r\n  background-color: inherit !important;\r\n  border: inherit !important;\r\n  color: #65717B;\r\n}\r\n\r\n.arrowBtn:hover {\r\n  background-color: #DFDFDF !important;\r\n}\r\n\r\n.deleteDialogBtn {\r\n  width: 100%;\r\n  background-color: #DD0000;\r\n  border-radius: 16px;\r\n  padding: 18px 20px;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #ffffff;\r\n  border: none;\r\n}\r\n\r\n.deleteDialogBtn:hover {\r\n  background-color: #721010;\r\n}\r\n\r\n.cancelDialogBtn {\r\n  width: 100%;\r\n  background-color: #F3F5F7;\r\n  border-radius: 16px;\r\n  padding: 10px 20px;\r\n  color: #4D87BE;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  border: none;\r\n}\r\n\r\n.cancelDialogBtn:hover {\r\n  color: #305375;\r\n}\r\n\r\n.deleteModal {\r\n  width: 541px !important;\r\n  height: 354px !important;\r\n  background-color: #F3F5F7;\r\n  border-radius: 25px !important;\r\n}\r\n\r\n.deleteModal :global(.p-dialog) {\r\n  border-radius: 25px !important;\r\n  background-color: #F3F5F7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-footer) {\r\n  border-bottom-right-radius: 25px !important;\r\n  border-bottom-left-radius: 25px !important;\r\n  background-color: #F3F5F7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-header) {\r\n  border-top-right-radius: 25px !important;\r\n  border-top-left-radius: 25px !important;\r\n  background-color: #F3F5F7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-content){\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.deleteModal .text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-title) {\r\n  font-size: 30px !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-content) {\r\n  background-color: #F3F5F7;\r\n}\r\n\r\n.diningOptionModal {\r\n  width: 42.125rem !important;\r\n  height: fit-content !important;\r\n  border-radius: 1rem !important;\r\n}\r\n\r\n.diningOptionModal :global(.p-dialog-content) {\r\n  background-color: #F3F5F7;\r\n  height: fit-content !important;\r\n}\r\n\r\n.diningOptionModal :global(.p-dialog) {\r\n  border-radius: 1rem !important;\r\n}\r\n\r\n.diningOptionModal :global(.p-dialog-header) {\r\n  background-color: #F3F5F7;\r\n  border-top-right-radius: 1rem !important;\r\n  border-top-left-radius: 1rem !important;\r\n}\r\n\r\n.diningOptionModal :global(.p-dialog-footer) {\r\n  background-color: #F3F5F7;\r\n  border-bottom-right-radius: 1rem !important;\r\n  border-bottom-left-radius: 1rem !important;\r\n}\r\n\r\n.diningOptionModal :global(.p-dialog-title) {\r\n  font-size: 1.875rem !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.diningOptionModal :global(.field) label {\r\n  font-size: 1.25rem !important;\r\n  font-weight: 400 !important;\r\n}\r\n\r\n.input {\r\n  border-radius: 16px;\r\n  font-size: 18px;\r\n  padding: 14px 20px;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.selectButton {\r\n  background-color: #e1e7ed;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n}\r\n\r\n.selectButton :global(.p-button) {\r\n  background-color: transparent;\r\n  border: none;\r\n  font-size: 20px;\r\n  padding: 15px 0px;\r\n}\r\n\r\n.selectButton :global(.p-highlight) {\r\n  background-color: #4d87be;\r\n  border-radius: 16px;\r\n}\r\n\r\n.saveBtn {\r\n  width: 100%;\r\n  background-color: #56be4d;\r\n  border-radius: 16px;\r\n  padding: 18px 0px;\r\n  color: #ffffff;\r\n  border: none;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.saveBtn:hover {\r\n  background-color: #185625;\r\n}\r\n\r\n.cardList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  margin-top: 15px;\r\n}\r\n\r\n.cardItem {\r\n  background: #ffffff;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n  display: grid;\r\n  grid-template-columns: 2fr 2fr 1fr;\r\n  align-items: center;\r\n}\r\n\r\n.cardInfo {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.name {\r\n  font-weight: 500;\r\n  color: #303030;\r\n  font-size: 14px;\r\n}\r\n\r\n.subfield {\r\n  color: #888888;\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n  margin-left: 3px;\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.cardEditBtn {\r\n  color: #1976d2;\r\n  background: none;\r\n  border: none;\r\n}\r\n\r\n.cardDeleteBtn {\r\n  color: #d32f2f;\r\n  background: none;\r\n  border: none;\r\n}\r\n\r\n.cardArrowBtn {\r\n  background: none;\r\n  border: none;\r\n  color: #65717B;\r\n}\r\n\r\n.cardArrowBtn:disabled {\r\n  color: #BFC4C8;\r\n}\r\n\r\n.cardArrowBtn i::before,\r\n.cardEditBtn i::before,\r\n.cardDeleteBtn i::before {\r\n  font-size: 18px;\r\n}\r\n\r\n@media screen and (max-width: 686px) {\r\n  .deleteModal,\r\n  .diningOptionModal {\r\n    width: 350px !important;\r\n  }\r\n  \r\n  .diningOptionModal :global(.field) label {\r\n    font-size: 14px !important;\r\n  }\r\n  \r\n  .deleteModal :global(.p-dialog-title),\r\n  .diningOptionModal :global(.p-dialog-title) {\r\n    font-size: 20px !important;\r\n    font-weight: 700 !important;\r\n  }\r\n  \r\n  .deleteModal .text {\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .input {\r\n    font-size: 14px;\r\n    padding: 14px 20px;\r\n    background-color: #ffffff;\r\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);\r\n  }\r\n  \r\n  .saveBtn {\r\n    padding: 14px 0;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .deleteDialogBtn {\r\n    border-radius: 8px;\r\n    padding: 14px 16px;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .cancelDialogBtn {\r\n    border-radius: 8px;\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .selectButton {\r\n    background-color: #e1e7ed;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .selectButton :global(.p-button) {\r\n    background-color: transparent;\r\n    border: none;\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    padding: 15px 0;\r\n  }\r\n  \r\n  .selectButton :global(.p-highlight) {\r\n    background-color: #4d87be;\r\n    border-radius: 8px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 545px) {\r\n  .pageHeader {\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: start;\r\n  }\r\n  \r\n  .pageHeader h2 {\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n  }\r\n  \r\n  .dropdown {\r\n    width: 100%;\r\n    font-size: 14px !important;\r\n    border-radius: 16px;\r\n    padding: 4px 6px;\r\n    height: 44px;\r\n  }\r\n  \r\n  .dropdown::placeholder {\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .createBtn {\r\n    width: 100%;\r\n    height: 26px;\r\n    border-radius: 6px;\r\n    margin-bottom: 14px;\r\n  }\r\n  \r\n  .createBtn span {\r\n    display: none;\r\n  }\r\n  \r\n  .createBtn i {\r\n    width: 100%;\r\n    font-size: 14px;\r\n    background-color: #f2e1bc;\r\n    padding: 10px;\r\n    border-radius: 6px;\r\n    margin-right: 0;\r\n  }\r\n  \r\n  .actionsText {\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    color: #7B7B7B;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export var pageWrapper = `_RkapjXyJkXgaq5d`;
export var pageHeader = `py3sW3Bx2lsKNX5A`;
export var header = `AK5X0BQQwF8tXipT`;
export var diningOptionItem = `UQZBC3SxllgwWvWU`;
export var dropdown = `d1ZdVqDwQts8QI41`;
export var createBtn = `xR9s4MvcLNgPLlMo`;
export var orderListItem = `hl4SIjcSx5owzpDT`;
export var column1 = `QBC35JF2pF4dUEEN`;
export var activeBtn = `VXfasF6bqr0tAMmL`;
export var cellSoundWrapper = `rp2GoM_r5wU_wHHG`;
export var soundBtn = `iYa1dTGHSAhjzDJo`;
export var deleteBtn = `sRkHkq7bWzAupkHk`;
export var arrowBtn = `QoDHM8xhnBwPhAfm`;
export var deleteDialogBtn = `pnezgTf6ng4K5JMo`;
export var cancelDialogBtn = `cMWSguHWcs8uOrfo`;
export var deleteModal = `Z9iwHkKLwQQ6ntdN`;
export var text = `OlWviwg2PUgzCdSm`;
export var diningOptionModal = `MMxSsOen_k0MGQzh`;
export var input = `AgzvqLIEJogxJej0`;
export var selectButton = `JJkGFW9_nbk8ROV_`;
export var saveBtn = `HyMOyeYtr48JKEt5`;
export var cardList = `p82ZaIxZAdQzdPFt`;
export var cardItem = `bauKJZtmfUHXvdyO`;
export var cardInfo = `WTaiB_6fZKcn34ou`;
export var name = `tXChdoYj3EdXj0wU`;
export var subfield = `pBcgYnbhkfDHiCDA`;
export var actions = `ahj91rQAoAEpGW3N`;
export var cardEditBtn = `fSI8puu5TYAotecZ`;
export var cardDeleteBtn = `TwRDpHz08b4DRhkw`;
export var cardArrowBtn = `pJDbA9kNYEMjDs_9`;
export var actionsText = `V9wP5i44TEIrA5CM`;
export default ___CSS_LOADER_EXPORT___;
